export default __webpack_public_path__ + "static/media/proclamation5.e11838ea.jpg";